import { useSession } from '@/auth/useSession';
import { isAirAdmin } from '@airreading/common';
import { TriangleAlertIcon } from 'lucide-react';

export const ImpersonationAlertBanner = () => {
  const { isImpersonating, actingUser } = useSession();

  if (!isImpersonating) return null;

  const { fullName } = actingUser;
  const hasAdminRole = isAirAdmin(actingUser);

  return (
    <div className="mx-2 mb-2 min-w-0 bg-yellow-50 border-t-4 border-yellow-400 p-3 dark:bg-gray-800 dark:border-yellow-500">
      <div className="flex min-w-0 items-start gap-2 text-yellow-800 dark:text-yellow-200">
        <TriangleAlertIcon className="h-5 w-5 shrink-0" />
        <h3 className="min-w-0 text-xs font-semibold break-words [overflow-wrap:anywhere]">Impersonating {fullName}</h3>
      </div>
      <div className="mt-2 min-w-0 text-xs text-yellow-700 dark:text-yellow-300 space-y-1 break-words [overflow-wrap:anywhere]">
        <p>
          You are impersonating {fullName}. All data you see is from {fullName}. All actions will be performed as{' '}
          {fullName}.
        </p>
        {hasAdminRole && <p>Admin-only actions are disabled while impersonating this user.</p>}
      </div>
    </div>
  );
};
